import React, { Suspense, lazy } from 'react'
import PropTypes from 'prop-types'
import { Card, Skeleton, Typography } from '@chilecompra/react-kit/components'
import { Label } from './PurchaseOrderStatus.styles'
import { columns } from '../SendSellerQuoteDialog/SendSellerQuoteDialog.constants'

const FirstPoint = lazy(() => import('./PutchaseOrderStatus.FirstPoint'))
const DJAditionalDetailInfo = lazy(() => import('../../components/Custom/DJAditionalDetail'))
const DynamicTable = lazy(() => import('../../components/Custom/DynamicInputsTable'))

/**
 * The Purchase Order Status Declaration's component.
 */
const PurchaseOrderStatusDeclaration = props => {
  const {
    swornDeclaration: { bussineName, dni, fullName, shippingDate, DJAditionalDetail, DJBeneficiaries }
  } = props

  return (
    <Card color="blank" enableBorder>
      <Typography color="black1" fontSize="16px" fontWeight="bold" lineHeight="18px" margin="20px 0" variant="h3">
        Declaración Jurada de Requisitos para Ofertar
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        Con fecha
        <Label>
          {shippingDate}, {fullName}-
        </Label>
        , ha declarado bajo juramento que no se encuentra afecto(a), o, si es el caso, su representada
        <Label>
          {bussineName || <Skeleton />} {dni}
        </Label>
        no se encuentra afecta, a ninguna de las inhabilidades legales que se mencionan en esta declaración:
      </Typography>
      <FirstPoint shippingDate={shippingDate} />
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        2.- No he sido condenado, o mi representada no ha sido condenada, por el Tribunal de Defensa de la Libre
        Competencia, dentro de los 5 años anteriores, contados desde que la sentencia definitiva quede ejecutoriada, con
        la prohibición de contratar a cualquier título con órganos de la administración, contemplada en el artículo 26,
        letra d), del Decreto con Fuerza de Ley N°1, de 2004, del Ministerio de Economía, Fomento y Reconstrucción, que
        Fija el texto refundido, coordinado y sistematizado del decreto ley N°211, de 1973.
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        3.- Mi representada no ha sido condenada a la pena de prohibición de celebrar actos y contratos con organismos
        del Estado, por los delitos mencionados en la ley N°20.393.
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        4.- No he sido condenado por los Tribunales de Justicia a la medida dispuesta en el artículo 33 de la ley
        N°21.595 de Delitos Económicos. En el caso de que mi representada sea una persona jurídica, ya sea que se trate
        de sociedades, fundaciones o corporaciones, declaro que esta no tiene como socio, accionista, miembro o
        partícipe con poder para influir en la administración, a personas naturales que hubieran sido condenadas a la
        citada medida.
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        5.- No soy ni he sido durante el período de un año transcurrido con antelación a la presente declaración,
        funcionario directivo del organismo licitante y/o comprador, hasta el nivel de jefe de departamento o su
        equivalente, o funcionario que participe en procedimientos de contratación del organismo licitante y/o
        comprador, ni estoy unido(a) a éstos o aquéllos por los vínculos descritos en la letra b) del artículo 54 de la
        ley N°18.575 (cónyuge, hijo, adoptado o pariente hasta el tercer grado de consanguinidad y segundo de afinidad
        inclusive).
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        6.- No integro la nómina de personal del organismo licitante y/o comprador, en cualquier calidad jurídica, ni
        soy contratado a honorarios por el organismo licitante y/o comprador, ni estoy unido(a) a éstos o aquéllos por
        los vínculos descritos en el inciso primero del artículo 35 quáter de la ley N°19.886 (cónyuge, convivientes
        civil o pariente hasta el segundo grado de consanguinidad o afinidad).
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        7.- Mi representada no es una sociedad de personas, empresa individual de responsabilidad limitada, sociedad en
        comandita por acciones o anónima cerrada en la que una o más de las personas singularizadas en los párrafos
        quinto y sexto precedentes formen parte o sean beneficiarias finales o una sociedad anónima abierta en que tales
        personas sean dueñas de acciones que representen el 10% o más del capital o sean beneficiarias finales.
      </Typography>
      <Typography color="black1" fontSize="13px" lineHeight="15px" margin="20px 0" variant="body2">
        8.- No soy gerente, administrador, representante o director de cualquiera de las sociedades antedichas.
      </Typography>
      <Suspense fallback={<Skeleton />}>
        <DJAditionalDetailInfo DJAditionalDetail={DJAditionalDetail} />
        <DynamicTable rows={DJBeneficiaries} setRows={() => {}} columns={columns} readOnly />
      </Suspense>
    </Card>
  )
}

const DJBeneficiariesTablePropTypes = {
  DJBeneficiaries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      razonSocial: PropTypes.string,
      rut: PropTypes.string
    })
  )
}

PurchaseOrderStatusDeclaration.propTypes = {
  swornDeclaration: PropTypes.shape({
    bussineName: PropTypes.string.isRequired,
    dni: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    shippingDate: PropTypes.string.isRequired,
    DJAditionalDetail: PropTypes.string,
    DJBeneficiaries: DJBeneficiariesTablePropTypes
  }).isRequired
}

export default PurchaseOrderStatusDeclaration
